import { trackFullStoryEvent } from "utils/mrTracker";
import { uuidv4 } from "utils/cryptoRandomString";

export const GLOBAL_SEARCH_FULLSTORY_EVENTS = {
    OPENED: "global_search.opened",
    RESULT_CLICKED: "global_search.result_clicked",
    ABANDONED: "global_search.abandoned"
};

const RESULT_CATEGORIES = {
    "console-object": "console_objects",
    "knowledge-base": "knowledge_base",
    documentation: "documentation",
    "services-and-features": "services_and_features"
};

let session = null;

export const resetGlobalSearchSession = () => {
    session = null;
};

export const inputMethodFromInteraction = event => event?.detail > 0 ? "mouse" : "keyboard";

export const matchTypeForLabel = (label, searchTerm) => {
    const term = typeof searchTerm === "string" ? searchTerm.trim().toLowerCase() : "";
    const value = typeof label === "string" ? label.trim().toLowerCase() : "";
    return term && value === term ? "exact" : "partial";
};

export const globalSearchResultCategory = actionType => {
    const key = String(actionType || "").split("/").pop();
    return RESULT_CATEGORIES[key] || key;
};

export const hasGlobalSearchResults = globalSearch => {
    const documentation = globalSearch?.documentationResults || {};
    return (globalSearch?.consoleObjects?.results?.length > 0)
        || (documentation["Knowledge Base"]?.length > 0)
        || (documentation["NetApp Documentation"]?.length > 0);
};

const track = (name, payload) => {
    trackFullStoryEvent({ name, payload });
};

export const trackGlobalSearchOpened = ({ inputMethod, page } = {}) => {
    if (session) {
        return;
    }
    session = {
        searchSessionId: uuidv4(),
        queryCount: 0,
        resultClicked: false
    };
    track(GLOBAL_SEARCH_FULLSTORY_EVENTS.OPENED, {
        search_session_id: session.searchSessionId,
        page: page || "",
        input_method: inputMethod || "mouse"
    });
};

export const recordGlobalSearchQuery = () => {
    if (!session) {
        return;
    }
    session.queryCount += 1;
};

export const trackGlobalSearchResultClicked = ({ category, objectType, rank, matchType, inputMethod } = {}) => {
    if (session?.resultClicked) {
        return;
    }
    if (session) {
        session.resultClicked = true;
    }
    track(GLOBAL_SEARCH_FULLSTORY_EVENTS.RESULT_CLICKED, {
        search_session_id: session?.searchSessionId || "",
        category: category || "",
        object_type: objectType || "",
        rank: typeof rank === "number" ? rank : null,
        match_type: matchType || "partial",
        input_method: inputMethod || "mouse"
    });
};

export const trackGlobalSearchAbandoned = ({ hadResults } = {}) => {
    if (!session || session.resultClicked) {
        session = null;
        return;
    }
    track(GLOBAL_SEARCH_FULLSTORY_EVENTS.ABANDONED, {
        search_session_id: session.searchSessionId,
        had_results: !!hadResults,
        query_count: session.queryCount
    });
    session = null;
};
